import { Loader2 } from 'lucide-react';

interface SpinnerProps {
  size?: number;
  className?: string;
  label?: string;
}

// Small inline loading indicator using the accent token.
export default function Spinner({ size = 18, className = '', label }: SpinnerProps) {
  return (
    <span className={`inline-flex items-center gap-2 text-ws-ink-3 ${className}`}>
      <Loader2 size={size} className="animate-spin text-ws-accent" />
      {label && <span className="text-sm">{label}</span>}
    </span>
  );
}
